// extracted by mini-css-extract-plugin
export default {"container_bu":"globals_container_bu__k4Qsz","columns":"globals_columns__SJwRn"};